import { CommonModule } from '@angular/common';
import { Component } from '@angular/core';
import { RouterModule } from '@angular/router';

import { MatButtonModule } from '@angular/material/button';
import { MatIconModule } from '@angular/material/icon';
import { MatMenuModule } from '@angular/material/menu';
import { MatPaginatorModule } from '@angular/material/paginator';

import { AlertComponent } from '@shared/components/alert/alert.component';
import { Pagination } from '@shared/models/Pagination.model';
import { ElementModel } from '@shared/models/Element.model';
import { Coupon } from '@admin/models/Coupon.model';

import {
  SearchBarComponent,
  CrudComponent,
  CrudHeaderComponent,
} from '@admin/components';

@Component({
  selector: 'app-coupons',
  standalone: true,
  imports: [
    CommonModule,
    RouterModule,
    MatPaginatorModule,
    MatButtonModule,
    MatMenuModule,
    MatIconModule,
    AlertComponent,
    CrudHeaderComponent,
    SearchBarComponent,
  ],
  templateUrl: './coupons.component.html',
  styleUrl: './coupons.component.scss',
})
export class CouponsComponent extends CrudComponent {
  override data: Pagination<Coupon> = new Pagination(Coupon);
  override filters: ElementModel[] = [
    { label: 'Activo', value: '1' },
    { label: 'Inactivo', value: '0' },
  ];

  override handleLoadResponse(responses: any[]): void {
    if (responses[0].data) this.data.setData(responses[0].data);

    this.pagination.set(this.data.rows.length > 0);
    this.stopLoading();
  }
}
